import { Button, Modal, message } from "antd";
import { isSupportAgent3, isDev } from "../../../helpers/genericHelper";
import LoaderComponent from "../../Loader";
import API from "../../../services/API";
import { useState } from "react";

function AuditProfile({ userId, modalLoading, showModalLoading, reloadData }) {
  const [modalAuditVisible, setmodalAuditVisible] = useState(false);
  const [auditData, setAuditData] = useState({});

  const auditProfile = async () => {
    try {
      showModalLoading(true);
      const response = await API.riskCheck(userId, "PROFILE_AUDIT");
      setAuditData(response.kycResult);
      message.success("Profile audit completed successfully");
      showModalLoading(false);
    } catch (e) {
      message.error("Unable to complete profile audit" + e.toString());
      console.error(e)
      showModalLoading(false);
      setmodalAuditVisible(false);
    }
  }

  return (
    <>
      {isSupportAgent3() &&
        <Button
          className="card-bottom-buttons"
          type="primary"
          onClick={() => setmodalAuditVisible(true)}>
          Run Profile Audit
        </Button>
      }

      <Modal
        title={Object.keys(auditData).length === 0 ? "Confirm Profile Audit" : "Profile Audit Results"}
        centered
        open={modalAuditVisible}
        onOk={Object.keys(auditData).length === 0 ? auditProfile : null}
        onCancel={() => {
          // Refresh on close, because refreshing earlier would close the results
          const auditRan = Object.keys(auditData).length > 0;
          setmodalAuditVisible(false);
          setAuditData({});
          if (auditRan && reloadData) reloadData();
        }}
        closable={true}
        className="confirm-modal"
        okText="Run Audit"
        cancelText="Close"
        width={600}
        okButtonProps={{ hidden: Object.keys(auditData).length > 0 }}
      >
        {Object.keys(auditData).length === 0 ? (
          <>
            <p>Are you sure you want to run a profile audit on this user?</p>
            {modalLoading && <LoaderComponent />}
          </>
        ) : (
          <div>
            <p><strong>KYC Status:</strong> {auditData.kycStatus}</p>
            <p><strong>Can Retry KYC:</strong> {auditData.canRetryKyc ? 'Yes' : 'No'}</p>
            <p><strong>Provider: </strong>{auditData.provider}</p>
            <p><strong>Document Verification Allowed:</strong> {auditData.isDocumentVerificationAllowed ? 'Yes' : 'No'}</p>
            <p>Please see the Sardine Console for the full report</p>
          </div>
        )}
      </Modal>
    </>
  );
}

export default AuditProfile;